/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable max-len */
const moment = require('moment');
const { min } = require('lodash');

const createDate = date => (date ? moment(date).format('DD MMM YYYY') : null);
const vehicleReqDate = (sources, format) => moment(min(sources.map(_obj => _obj.loading_date) || [])).format(format);
const routeDetails = routeLocation => routeLocation.tooltip_text;
const routeShortForm = routeLocation => routeLocation.route;

export const indentsMenu = [{
  id: 'indents',
  name: 'indents',
}];

export const historicIndentsMenu = [{
  id: 'Historic Indent',
  name: 'Historic Indent',
}];

export const bidsMenu = [{
  id: 'bids',
  name: 'bids',
}];

export const firstInAllotmentMenu = [{
  id: 'first_in_allotment',
  name: 'First In Allotment',
}];

export const indentRepublishRequestsMenu = [{
  id: 'indent_requests',
  name: 'Indent Requests',
}];

export const indentRepublishRequestsSearchParameters = [
  {
    id: 'indent_id',
    name: 'Indent ID',
    query: 'order_no',
    tname: 'INDENT_INDENT_ID',
  },
];

export const indentRepublishRequestsHeader = [{
  title: 'Indent ID',
  label: 'order_no',
  tlabel: 'INDENT_INDENT_ID',
  colSpan: 4,
},
{
  title: 'Status',
  tlabel: 'INDENT_STATUS',
  label: 'status',
  data: {
    key: 'status',
  },
  colSpan: 3,
  truncate_on: 20,
},
{
  title: 'Route',
  label: 'route',
  tlabel: 'INDENT_ROUTE',
  colSpan: 3,
  tooltip: true,
},
];

export const firstInAllotmentSearchParameters = [
  {
    id: 'indent_id',
    name: 'Indent ID',
    query: 'order_no',
    tname: 'INDENT_INDENT_ID',
  },
];

export const searchParameters = [
  {
    id: 'indent_id',
    name: 'Indent ID',
    query: 'order_no',
    tname: 'INDENT_INDENT_ID',
  },
  {
    id: 'materials_invoice_no',
    name: 'Materials Invoice Number',
    query: 'materials_invoice_no',
  },
  {
    id: 'vehicle_number',
    name: 'Vehicle Number',
    query: 'vehicle_no',
    tname: 'INDENT_VEHICLE_NUMBER',
  },
  {
    id: 'lr_number',
    name: 'lr number',
    query: 'lr_number',
    tname: 'INDENT_LR_NUMBER',
  },
  {
    id: 'destination_consignee',
    name: 'drop off consignee',
    query: 'destination_consignee',
    placeholder: 'Consignee Name or Ref ID',
    tname: 'INDENT_DROP_OFF_CONSIGNEE',
    tplaceholder: 'INDENT_CONSIGNEE_NAME_REF_ID',
  },
  {
    id: 'destination_depot',
    name: 'drop off depot',
    tname: 'INDENT_DROP_OFF_DEPOT',
    query: 'destination_depot',
    placeholder: 'Depot Name or Ref ID',
    tplaceholder: 'INDENT_DEPOT_NAME_REF_ID',
  },
  {
    id: 'delivery_number',
    name: 'delivery number',
    query: 'delivery_number',
    tlabel: 'INDENT_DELIVERY_NUMBER',
  },
  {
    id: 'consignment_number',
    name: 'consignment number',
    query: 'consignment_number',
    tlabel: 'INDENT_CONSIGNMENT_NUMBER',
  },
  {
    id: 'shipment_number',
    name: 'shipment number',
    query: 'shipment_number',
    tlabel: 'INDENT_SHIPMENT_NUMBER',
  },
];

export const filters = {
  DEPOT: 'Depot',
  GATE: 'Gate',
  DATE_PICKER: 'Date Picker',
  CREATION_DATE: 'Creation Date',
  VEH_DATE: 'Vehicle Requirement Date',
  EDD_DATE: 'Edd Date',
  STATUS: 'Status',
  MOVEMENT: 'Movements',
};

export const indentsStatus = [
  { id: 0, name: 'Select All', tlabel: 'INDENT_ALL_STATUSES' },
  { id: 1, status_id: 0, name: 'Indented', color: 'purple', tlabel: 'INDENT_INDENTED_STATUS' },
  { id: 3, status_id: 3, name: 'Accepted', tlabel: 'INDENT_ACCEPTED_STATUS' },
  { id: 4, status_id: 4, name: 'Assigned', color: 'pink', tlabel: 'INDENT_ASSIGNED_STATUS' },
  { id: 5, status_id: 5, name: 'Arrived', color: 'teal', tlabel: 'INDENT_ARRIVED_STATUS' },
  { id: 6, status_id: 6, name: 'Dispatched', color: 'blue', tlabel: 'INDENT_DISPATCHED_STATUS' },
  { id: 8, status_id: 8, name: 'Cancelled', color: 'red', tlabel: 'INDENT_CANCELLED_STATUS' },
  { id: 16, status_id: 16, name: 'Inspection Rejected', color: 'teal', tlabel: 'INDENT_INSPECTION_REJECTED_STATUS' },
  { id: 23, status_id: 23, name: 'Delivered', color: 'green', tlabel: 'INDENT_DELIVERED_STATUS' },
  { id: 26, status_id: 26, name: 'Container picked', color: 'teal', feature: 'exim_enabled', tlabel: 'INDENT_CONTAINER_PICKED_STATUS' },
  { id: 11, status_id: 11, name: 'Reported at destination', tlabel: 'INDENT_REPORTED_AT_DESTINATION_STATUS' },
  { id: 12, status_id: 12, name: 'Unloading Started', tlabel: 'INDENT_UNLOADING_STARTED_STATUS' },
  { id: 40, status_id: 40, name: 'Not Delivered', tlabel: 'NOT_DELIVERED', color: 'yellow', feature: 'indent_not_delivered' },
  // { id: 13, status_id: 39, name: 'Pending', color: 'pink', tlabel: 'INDENT_PENDING' },
];
export const indentMovementTypes = [
  { id: -1, name: 'All Movement Types', tlabel: 'INDENT_ALL_MOVEMENT_TYPES' },
  { id: 1, name: 'Secondary', tlabel: 'INDENT_SECONDARY' },
  { id: 2, name: 'Primary', tlabel: 'INDENT_PRIMARY' },
  { id: 3, name: 'Vendor', tlabel: 'INDENT_VENDOR' },
  { id: 4, name: 'Returns', tlabel: 'INDENT_RETURNS' },

];

export const indentsHeader = [{
  title: 'Indent ID',
  tlabel: 'INDENT_INDENT_ID',
  label: 'order_no',
  colSpan: 3,
  data: {
    key: 'order_no',
  },
  truncate_on: 20,
  dependency: {
    is_enabled: true,
    data: {
      key: 'created_at',
      view_rule: date => createDate(date),
    },
    truncate_on: 20,
  },
},
{
  title: 'Status',
  tlabel: 'INDENT_STATUS',
  label: 'status',
  data: {
    key: 'status',
  },
  colSpan: 3,
  truncate_on: 20,
},
{
  title: 'Route',
  tlabel: 'INDENT_ROUTE',
  label: 'route',
  colSpan: 4,
  tooltip: true,
  data: {
    key: 'route',
    view_rule: routeLocation => routeShortForm(routeLocation),
  },
  expanded_text: {
    data: {
      key: 'route',
      view_rule: routeLocation => routeDetails(routeLocation),
    },
    truncate_on: 20,
  },
  truncate_on: 20,
},
{
  title: 'Vehicle & Date',
  tlabel: 'INDENT_VEHICLE_AND_DATE',
  label: 'vehicle_type',
  colSpan: 4,
  data: {
    key: 'vehicle_type',
  },
  truncate_on: 20,
  dependency: {
    is_enabled: true,
    data: {
      key: 'vechile_req_date',
      view_rule: date => vehicleReqDate(date),
    },
    truncate_on: 20,
  },
}];

export const bidsHeader = [{
  title: 'Indent ID',
  label: 'order_no',
  tlabel: 'BIDS_HEADER_ORDER_NO',
  colSpan: 3,
},
{
  title: 'Route',
  label: 'route',
  tlabel: 'BIDS_HEADER_ROUTE',
  colSpan: 3,
  tooltip: true,
},
{
  title: 'Vehicle & Date',
  label: 'vehicle_type',
  tlabel: 'BIDS_HEADER_VEHICLE_TYPE',
  colSpan: 4,
},
{
  title: 'Bid Closure on',
  label: 'expires_at',
  tlabel: 'BIDS_HEADER_EXPIRES_AT',
  colSpan: 3,
}];

export const firstInAllotmentHeader = [{
  title: 'Indent ID',
  label: 'order_no',
  tlabel: 'INDENT_INDENT_ID',
  colSpan: 3,
},
{
  title: 'Status',
  tlabel: 'INDENT_STATUS',
  label: 'status',
  data: {
    key: 'status',
  },
  colSpan: 3,
  truncate_on: 20,
},
{
  title: 'Route',
  label: 'route',
  tlabel: 'INDENT_ROUTE',
  colSpan: 3,
  tooltip: true,
},
{
  title: 'Vehicle & Date',
  label: 'vehicle_type',
  tlabel: 'INDENT_VEHICLE_AND_DATE',
  colSpan: 4,
},
];

export const orderTypes = [
  {
    name: 'CONTRACT',
    id: 0,
    label: 'Contract',
    icon: 'status_contract',
    tlabel: 'INDENT_CONTRACT',
  },
  {
    name: 'OPEN',
    id: 1,
    label: 'Open',
    icon: 'status_open',
    tlabel: 'INDENT_OPEN',
  },
  {
    name: 'NO FREIGHT',
    id: 2,
    label: 'No Freight',
    icon: 'status_nofreight',
    tlabel: 'INDENT_NO_FREIGHT',
  },
  {
    name: 'MARKET',
    id: 3,
    label: 'Market',
    icon: 'status_market',
    tlabel: 'INDENT_MARKET',
  },
];

export const movementTypes = [
  { id: 1, name: 'Secondary', icon: 'secondary' },
  { id: 2, name: 'Primary', icon: 'primary' },
  { id: 3, name: 'Vendor', icon: 'status_vendor' },
  { id: 4, name: 'Return', icon: 'status_return' },
];

export const vehicleTypes = [
  { id: 'FTL', name: 'FTL' },
  { id: 'PTL', name: 'PTL', icon: 'ptl' },
];

export const contractTypes = [
  { id: 1, name: 'Per Trip' },
  { id: 2, name: 'Per Ton' },
  { id: 3, name: 'Per Kg' },
  { id: 4, name: 'Per CFT' },
  { id: 5, name: 'Per Package' },
  { id: 6, name: 'Per Case' },
  { id: 7, name: 'Per Box' },
  { id: 8, name: 'Per KM' },
  { id: 9, name: 'Per %' },
];

export const indentRejectOptions = [
  { value: 'Vehicle type is not available in market', key: 'INDENT_REJECT_VEHICLE_TYPE_NA' },
  { value: 'Existing rates are not competitive', key: 'INDENT_REJECT_EXISTING_RATE_ARE_NOT_COMPETITIVE' },
  { value: 'Lane is not serviceable today', key: 'INDENT_REJECT_LANE_NOT_SERVICEABLE' },
]; // if anything edited here need to edit here too frontend/shipper/src/constants/reason-settings.js

export const bidsActions = [{
  id: 1,
  label: 'QUOTE REQUESTED',
},
{
  id: 3,
  label: 'QUOTE SENT',
  class: 'text-green1',
},
{
  id: 5,
  label: 'BID WITHDRAWN',
  class: 'text-red1',
},
{
  id: 7,
  label: 'COUNTER QUOTE REQUESTED',
  class: 'text-orange',
},
];

export const timelineLabels = {
  indent_created: {
    label: 'Indent Created',
    tlabel: 'INDENT_INDENT_CREATED',
  },
  indent_accepted: {
    label: 'Indent Accepted',
    tlabel: 'INDENT_INDENT_ACCEPTED',
  },
  truck_assigned: {
    label: 'Truck Assigned',
    tlabel: 'INDENT_TRUCK_ASSIGNED',
  },
  vehicle_req_date: {
    label: 'Vehicle Requirement Date',
    tlabel: 'INDENT_VEHICLE_REQUIREMENT_DATE',
  },
  arrived_at: {
    label: 'Arrived at',
    tlabel: 'INDENT_ARRIVED_AT',
  },
  dispatched_at: {
    label: 'Dispatched at',
    tlabel: 'INDENT_DISPATCHED_AT',
  },
  reported_at: {
    label: 'Reported at',
    tlabel: 'INDENT_REPORTED_AT',
  },
  release_at: {
    label: 'Release at',
    tlabel: 'INDENT_RELEASE_AT',
  },
  indent_cancelled: {
    label: 'Indent Cancelled',
    tlabel: 'INDENT_INDENT_CANCELLED',
  },
  not_delivered: {
    label: 'Not Delivered',
    tlabel: 'INDENT_NOT_DELIVERED',
  },
  deliver_skip: {
    label: 'Delivery Skip',
    tlabel: 'INDENT_DELIVERY_SKIP',
  },
  actual_dispatch_initiated_at: {
    label: 'Actual Dispatch Time',
    tlabel: 'INDENT_ACTUAL_DISPATCHED_AT',
  },
  actual_delivery_executed_at: {
    label: 'Actual Delivery Time',
    tlabel: 'INDENT_ACTUAL_DELIVERED_AT',
  },
};

export const transporterActions = {
  reject: 'Reject Indent',
  change_truck_type: 'Change Truck Type',
  truck_in: 'Truck In',
  vehicle_details: 'Vehicle Details',
  truck_out: 'Truck Out',
  container_pickup: 'Container Pickup',
  assign_truck: 'Assign Truck',
  mark_as_delivered: 'Mark As Delivered',
  accept: 'Accept Indent',
  reject_truck: 'Reject Truck',
  last_mile_actions: 'Last Mile Actions',
  booking_confirmation: 'Booking Confirmation',
};
export const routerSourceAndDestinationType = {
  DEPOT: 1,
  CONSIGNEE: 2,
  VENDOR_DEPOT: 3,
  PORT: 4,
  NO_MASTER_ENTITY: 5,
  GATE: 6,
};
export const uploadType = {
  LOCATION_MILESTONE_UPLOAD: 'LOCATION_MILESTONE_UPLOAD',
  CONSIGNMENT_BULK_UPLOAD: 'CONSIGNMENT_BULK_UPLOAD',
  CHARGEABLE_WEIGHT_BULK_UPLOAD: 'CHARGEABLE_WEIGHT_BULK_UPLOAD',
  LR_UPLOAD: 'LR_UPLOAD',
  INDENT_ACTIONS_UPLOAD: 'INDENT_ACTIONS_UPLOAD',
  GRN_BULK_UPLOAD: 'GRN_BULK_UPLOAD',
};

export const buttonsList = [
  {
    show: true,
    name: 'Upload',
    dropdownList: [
      {
        type: 'upload',
        name: 'LR Status Upload',
        tlabel: 'LOCATION_MILESTONE_UPLOAD',
        sampleFileName: 'lr_status_bulk_upload.xlsx',
        uploadEmitMethod: 'locationMilestoneUpload',
        config: '',
        permission: 'milestone_lr_status_bulk_upload',
      },
      {
        type: 'upload',
        name: 'Chargeable Weight Bulk Upload',
        tlabel: 'CHARGEABLE_WEIGHT_BULK_UPLOAD',
        sampleFileName: 'chargeableWeightUploadSample.xlsx',
        uploadEmitMethod: 'chargeableWeightBulkUpload',
        config: '',
        permission: 'import_chargeable_weight',
      },
      {
        type: 'upload',
        name: 'LR Bulk Upload',
        tlabel: 'LR_UPLOAD',
        sampleFileEmitMethod: 'lrSampleFile',
        uploadEmitMethod: 'lrUpload',
        config: '',
        permission: 'lr_bulk_upload',
      },
      {
        type: 'upload',
        name: 'Indent Actions Upload',
        tlabel: 'UPLOAD_INDENT_ACTIONS',
        sampleFileEmitMethod: 'indentActionsSampleDownload',
        uploadEmitMethod: 'indentActionsUpload',
        config: '',
        permission: 'perform_indent_actions_upload',
        feature: 'indent_actions_upload',
      },
      {
        type: 'upload',
        name: 'GRN Bulk Upload',
        tlabel: 'GRN_BULK_UPLOAD',
        sampleFileEmitMethod: 'grnSampleDownload',
        uploadEmitMethod: 'grnBulkUpload',
        config: '',
        feature: 'transporter_grn_bulk_upload',
      },
    ],
  },
  {
    id: 'reject_list',
    name: 'Rejected List',
    show: false,
    class: 'header_sbtn',
    disabled: false,
    emitMethod: 'rejectDownload',
  },
  {
    id: 'bulk_pod_upload',
    name: 'BULK POD',
    show: true,
    class: 'header_sbtn',
    disabled: false,
    emitMethod: 'bulkPodUpload',
    feature: 'bulk_pod_upload',
    permission: [
      'transporter_pod_bulk_upload_primary',
      'transporter_pod_bulk_upload_secondary',
      'transporter_pod_bulk_upload_vendor',
      'transporter_pod_bulk_upload_return',
      'enable_pod_bulk_upload',
    ],
  },
];

export const deliveryPendingReasonsMapping = {
  1: 'Material Invoice N/A',
  2: 'Material Invoice N/A',
  3: 'EPOD N/A',
  4: 'OTP Verification',
  6: 'GRN Approval Pending',
  7: 'SAP Charges Pending',
};
